import React from 'react';

const timelineItems = [
  {
    year: '1888',
    title: 'Berthoud takes root',
    description:
      'Founded along the Colorado Central Railroad, the town grows around agriculture, ranching, and a shared commitment to the land.',
  },
  {
    year: 'Early 1900s',
    title: 'The sugar beet era',
    description:
      "Berthoud's fields become some of the most productive in northern Colorado. The community that forms around them values hard work, patience, and mutual reliance.",
  },
  {
    year: 'Mid-century',
    title: 'Steady growth, steady values',
    description:
      "As Colorado grows, Berthoud holds onto what matters: small-town character, agricultural identity, and a pace of life that respects the rhythms of the land.",
  },
  {
    year: 'Today',
    title: 'Garden Spot Development',
    description:
      'We carry that ethic forward\u2014as neighbors building a future rooted in the values that earned this place its name. Heritage and progress, hand in hand.',
    present: true,
  },
];

export default function Timeline() {
  return (
    <section className="timeline" aria-labelledby="timeline-heading">
      <div className="timeline-inner">
        <div className="timeline-header">
          <span className="eyebrow reveal">Rooted in this place</span>
          <h2 id="timeline-heading" className="reveal">A landscape shaped by care.</h2>
        </div>
        <ol className="timeline-track">
          {timelineItems.map((item) => (
            <li key={item.year} className={`timeline-item${item.present ? ' present' : ''} reveal`}>
              <p className="timeline-year">{item.year}</p>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
